















import Vue from 'vue'
import { IDevice } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { slaveDeviceDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { checkDeviceNameDuplicated } from '@/utils'

export default mixins(slaveDeviceDialogMixin).extend({
  data () {
    return {
      newName: ''
    }
  },
  computed: {
    device (): IDevice | null { return this.dialog.device },
    nameDuplicated (): boolean {
      if (!this.device) {return false}
      return checkDeviceNameDuplicated(this.newName, this.device.deviceName, this.$state.device.list)
    }
  },
  methods: {
    async apply () {
      if (!this.device) { return }
      const ok = await easyapi.renameDevice(this, this.device, this.newName)
      if (ok) {
        this.$emit('deviceRename')
        this.closeThisDialog()
      }
    }
  },
  watch: {
    device (dev: IDevice | null) {
      if (dev) { this.newName = dev.deviceName }
    }
  }
})
